import { createFileRoute, redirect } from '@tanstack/react-router';

// Bare URL `/` redirects to `/dashboard`. The /_auth guard on dashboard
// will further redirect to /login if the user isn't authenticated.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
